import { AUTH_URL } from "../../../config/config";
import { connection } from "../../../utils/connection";

const addPerson = async ({ params, token, callbacks }) => {
    const response = await connection({ method: 'POST', url: `${AUTH_URL.SIGNUP}`, extraHeaders: { token: token }, params: params });
    if (typeof callbacks === "function") {
        callbacks(response);
    }
}

export default addPerson;